import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MatPaginator, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin } from 'rxjs';
import { LevelHistoric } from '../../../core/models/levelHistoric.model';
import { Level } from '../../../core/models/level.model';
import { LevelType } from '../../../core/models/levelType.model';
import { Country } from '../../../model/country.enum';
import { CommercialStructureService } from '../../../core/services/commercial-structure.service';
import { AlertComponent } from '../alert/alert.component';
import { DialogSearchUserComponent } from '../dialog-search-user/dialog-search-user.component';
import { EnvironmentService } from '../../../service/environment.service';


import { customValidators} from '../../../model/validator/custom/customValidators';
@Component({
  selector: 'kt-dialog-commercial-structure',
  templateUrl: './dialog-commercial-structure.component.html',
  styleUrls: ['./dialog-commercial-structure.component.scss']
})
export class DialogCommercialStructureComponent implements OnInit {

  structureForm: FormGroup;
  levels: LevelType[] = [];
  isUserAssign: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  loading: boolean = false;
  isZone: boolean = false;
  isUruguay: boolean = false;
  historic: LevelHistoric[] = [];
  dataSource: MatTableDataSource<LevelHistoric>;
  displayedColumns = [
    'campaign',
    'applicationUserFirstName'
  ];

  constructor(
    public dialogRef: MatDialogRef<DialogCommercialStructureComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private commercialStructureService: CommercialStructureService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private environmentService : EnvironmentService

  ) { }

  ngOnInit() {
    this.structureForm = this.fb.group({
      level: ['', Validators.required],
      code: ['', [Validators.required, customValidators.LengthValidator(this.data.structureData.levelTypeId, this.data.isEdit), customValidators.ZoneValidator( this.data.structureData.levelTypeId, this.data.structureData.levelId, this.data.isEdit)]],
      description: ['', Validators.required],
      user: [''],
      userId: [''],
      isClosed: [false]
    });
    if(this.environmentService.country == Country.URUGUAY){
        this.isUruguay = true;
    }

    if (this.data.structureData.applicationUserId && this.data.isEdit) {
      this.isUserAssign = true;
    }

    forkJoin(
      this.commercialStructureService.getLevels(),
      this.commercialStructureService.getStructureHistoricByLevel(this.data.structureData.levelId)
    ).subscribe(([levels, historic]) => {
      this.levels = levels;
      this.historic = historic;


      this.initStructureForm();
      this.initTable();

    },
      error => {
        console.log(error);
      });




    }

  initTable() {
    this.dataSource = new MatTableDataSource(this.historic);
    this.paginator._intl.itemsPerPageLabel = 'Items por página';
    this.dataSource.paginator = this.paginator;
    this.paginator.length = this.historic.length;
    this.paginator.pageSize = 10;
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
		this.loading = false;
	}

  initStructureForm() {

    var currentLevel: LevelType[];
    if (this.data.structureData) {
      this.structureForm.controls['user'].disable();
      if (this.data.isEdit) {
        currentLevel = this.levels.filter(x => x.id == Number(this.data.structureData.levelTypeId));
        if(Number(this.data.structureData.levelTypeId) == 6){
            this.isZone = true;
        }
        if (currentLevel && currentLevel.length > 0) {
          this.levels = currentLevel;
          this.structureForm.controls['level'].setValue(currentLevel[0]);
          this.structureForm.controls['level'].disable();
          this.structureForm.controls['description'].setValue(this.data.structureData.levelName);
          if(this.environmentService.country == Country.URUGUAY){
            if(this.data.structureData.isClosed == null || this.data.structureData.isClosed == undefined) {
                this.structureForm.controls['isClosed'].setValue(false);
            } else{
                this.structureForm.controls['isClosed'].setValue(this.data.structureData.isClosed);
            }
          }

          this.structureForm.controls['code'].setValue(this.data.structureData.levelId);
          if (this.isUserAssign) {
            this.structureForm.controls['user'].setValue(
              this.data.structureData.applicationUserUserName + ' - ' +
              this.data.structureData.applicationUserFirstName + ' ' +
              this.data.structureData.applicationUserLastName
            );
            this.structureForm.controls['userId'].setValue(this.data.structureData.applicationUserId);
          }
        }
      } else {
        currentLevel = this.levels.filter(x => x.id == Number(this.data.structureData.levelTypeId));
        if (currentLevel && currentLevel.length > 0) {
          if (currentLevel[0].order != '5') {
             this.levels = this.levels.filter(x => Number(x.order) == Number(currentLevel[0].order) + 1);
          }
          if(currentLevel[0].id == 6) {
            this.structureForm.controls['code'].setValue(this.data.structureData.levelId);
          }
        }
      }
    }

  }

  selectLevel() {
    var lev = this.structureForm.controls['level'].value;
    this.structureForm.controls['description'].setValue(lev.name);
  }

  saveStructure() {

    const controls = this.structureForm.controls;
    if (this.structureForm.invalid) {
      Object.keys(controls).forEach(controlName => {
        controls[controlName].markAsTouched();
      }
      );
      return
    }

    this.loading = true;
    var id = null;
    if (this.structureForm.controls['user'].value != '') {
      id = this.structureForm.controls['userId'].value;
    }

    let request;
    if (this.data.isEdit) {

      request = {
        applicationUserId: id,
        name: (this.structureForm.controls['description'].value ? this.structureForm.controls['description'].value : null),
        isClosed: this.environmentService.country == Country.URUGUAY ? this.structureForm.controls['isClosed'].value : false
      }
      this.commercialStructureService.updateStructure(request, this.data.structureData.id).subscribe(
        x => {
          this.openSnackBar("Nivel de Estructura Comercial modificado con éxito", "Ok");
          this.dialogRef.close(true);
        },

        error => {
          const dialogRef = this.dialog.open(AlertComponent, {
            width: '400px',
            data: {
              mensaje: error.error.value ? error.error : "No se pudo modificar el Nivel de Estructura Comercial" ,
              title: 'Error'
            }
          });

          this.dialogRef.close(false);
        });
    } else {
      request = {
        campaignId: this.data.structureData.campaignId,
        applicationUserId: id,
        levelTypeId: this.structureForm.controls['level'].value.id,
        levelId: this.structureForm.controls['code'].value,
        isClosed: this.environmentService.country == Country.URUGUAY ? this.structureForm.controls['isClosed'].value : false,

        parentId: this.data.structureData.id,
        name: (this.structureForm.controls['description'].value ? this.structureForm.controls['description'].value : null)
      }

      console.log(request, 'add');

      this.commercialStructureService.saveStructure(request).subscribe(
        x => {
          this.openSnackBar("Nivel de Estructura Comercial agregado con éxito", "Ok");
          this.dialogRef.close(true);
        },
        error => {
          const dialogRef = this.dialog.open(AlertComponent, {
            width: '400px',
            data: {
              mensaje: error.error,
              title: 'Error'
            }
          });
          this.dialogRef.close(false);
        });
    }
  }

  quitUser(){
    this.structureForm.controls['user'].setValue(null);
    this.structureForm.controls['userId'].setValue(null);
    this.isUserAssign = false;
  }

  openDialogSearchUser() {
    const dialogRef = this.dialog.open(DialogSearchUserComponent, {
      width: '60%',
      //data: { userName: this.structureForm.controls['user'].value }
      data: { userName: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.structureForm.patchValue({ 'user': result.userName + ' - ' + result.firstName + ' ' + result.lastName });
        this.structureForm.patchValue({ 'userId': result.id });
        this.isUserAssign = true;
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.structureForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

}

export interface DialogData {
  structureData: Level;
  isEdit: boolean;
}
